import { Component, Input, OnInit } from '@angular/core';

interface ColorSchema {
  primary: string;
  secondary: string[];
}

@Component({
  selector: 'app-casino-preview',
  templateUrl: './casino-preview.component.html',
  styleUrls: ['./casino-preview.component.css'],
})
export class CasinoPreviewComponent implements OnInit {
  @Input() colors: ColorSchema | undefined;
  btnHover: boolean = false;
  gameHover: boolean = false;
  filterFocus: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  getBackground(index: number): string {
    try {
      return this.colors?.secondary?.[index - 1] ?? '';
    } catch (error) {
      return '';
    }
  }
}
